// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"346":"56a0002f","826":"f71ea761","893":"5a08faab"}[chunkId] + ".css";
};